/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type PatchPromptSnippetPathParams = NonNullable<operations['patchPromptSnippet']['parameters']['path']>;

export type PatchPromptSnippetRequestBody = OperationRequestBodyContent<operations['patchPromptSnippet']>;

export interface Input extends PatchPromptSnippetPathParams {
  apiVersion?: string;
  body: PatchPromptSnippetRequestBody;
}

export async function patchPromptSnippet(
  { apiVersion, body, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().PATCH('/api/v2/projects/{projectKey}/ai-configs/prompt-snippets/{snippetKey}', {
    params: { path },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
